import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetooutstationcabservice() {



  const cardData = {
    "keyword": "Pune Outstation Cab Service",

"headingDescription":
  "Shivai Travels provides dependable and affordable Pune Outstation Cab Service for travelers seeking comfortable and hassle-free journeys to nearby cities and tourist destinations. Whether you are planning a family vacation, business trip, weekend getaway, airport transfer, or religious tour, our outstation taxi service from Pune ensures safe and convenient travel with professional drivers and well-maintained vehicles. We offer transparent pricing with no hidden charges, flexible one-way and round-trip packages, and a wide range of vehicles including sedans, SUVs, and luxury cars to suit every travel requirement. With easy booking options and 24/7 customer support, Shivai Travels makes outstation travel from Pune smooth, reliable, and enjoyable.",

"topPlaces": [
  {
    "title": "Lonavala",
    "description":
      "Lonavala is a famous hill station near Pune known for its scenic valleys, waterfalls, and pleasant weather. Travelers using Pune Outstation Cab Service can comfortably enjoy a relaxing getaway surrounded by nature and beautiful mountain views."
  },
  {
    "title": "Mahabaleshwar",
    "description":
      "Mahabaleshwar is a popular hill destination known for strawberry farms, scenic viewpoints, and cool climate. A comfortable cab from Pune makes it easy to explore this peaceful destination with family and friends."
  },
  {
    "title": "Mumbai",
    "description":
      "Mumbai is a vibrant metropolitan city famous for iconic attractions, shopping streets, beaches, and business hubs. Travelers booking an outstation cab from Pune can enjoy a smooth and convenient journey to explore the city comfortably."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a renowned pilgrimage destination dedicated to Sai Baba and attracts devotees from across India. Pune Outstation Cab Service offers a comfortable and convenient option for spiritual travel to this sacred town."
  },
  {
    "title": "Nashik",
    "description":
      "Nashik is known for its vineyards, temples, and religious significance. Travelers from Pune can easily book an outstation taxi to enjoy sightseeing, spiritual visits, and wine tourism experiences in Nashik."
  },
  {
    "title": "Kolhapur",
    "description":
      "Kolhapur is famous for Mahalaxmi Temple, historical attractions, and traditional cuisine. A Pune outstation cab provides a relaxing and convenient travel experience to explore this culturally rich city."
  },
  {
    "title": "Goa",
    "description":
      "Goa is one of India’s most popular beach destinations known for nightlife, seafood, water sports, and scenic beaches. Travelers using Pune Outstation Cab Service can enjoy a comfortable road trip to this vibrant coastal state."
  },
  {
    "title": "Aurangabad",
    "description":
      "Aurangabad is known for historical sites like Ajanta and Ellora Caves along with rich Mughal heritage. A taxi from Pune offers a convenient travel option for exploring these UNESCO World Heritage attractions."
  },
  {
    "title": "Alibaug",
    "description":
      "Alibaug is a peaceful coastal destination famous for beaches, forts, and weekend getaways. Travelers from Pune can enjoy a relaxing road journey with an outstation cab to this scenic beach town."
  },
  {
    "title": "Satara",
    "description":
      "Satara is known for natural beauty, waterfalls, and historic forts surrounded by the Sahyadri hills. Pune Outstation Cab Service makes it easy for travelers to enjoy a refreshing trip to this beautiful destination."
  }
],



services: [
  {
    name: "Pune Outstation Cab Service",
    description: "Pune outstation cab service provides reliable transportation for travelers planning long-distance journeys from Pune to various cities and tourist destinations. Comfortable vehicles with experienced drivers ensure safe and smooth highway travel for families, tourists, and business travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Vehicles include sedan cars, SUVs, Innova Crysta, Ertiga, and tempo travellers suitable for different travel needs. Flexible booking options allow passengers to schedule one-way and round-trip journeys conveniently."
  },
  {
    name: "Outstation Cab Pune",
    description: "Outstation cab Pune service offers convenient intercity transportation for passengers traveling from Pune to nearby and long-distance destinations. Well-maintained vehicles provide comfortable seating and luggage space for highway travel. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from residential areas, corporate offices, hotels, railway stations, and airports. Flexible booking options allow travelers to plan business trips, family vacations, and weekend tours easily."
  },
  {
    name: "Pune Outstation Taxi",
    description: "Pune outstation taxi service provides dependable cab transportation for travelers looking for comfortable travel beyond city limits. Vehicles are suitable for long-distance journeys with spacious seating and modern travel amenities. Professional drivers ensure smooth travel on highways and major tourist routes. Pickup services are available from homes, hotels, offices, railway stations, and Pune Airport. Flexible booking options make it easy for passengers to reserve taxis for one-way and round-trip travel."
  },
  {
    name: "Outstation Taxi Service Pune",
    description: "Outstation taxi service Pune offers reliable transportation for passengers traveling to outstation destinations from Pune. Vehicles include sedan cars, SUVs, and premium vehicles suitable for family trips, corporate travel, and tourism. Professional drivers ensure safe and punctual journeys with comfortable highway travel experience. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow travelers to plan convenient intercity journeys."
  },
  {
    name: "Pune Outstation Car Rental",
    description: "Pune outstation car rental service provides comfortable rental vehicles for long-distance travel and outstation trips from Pune. Travelers can choose from sedan cars, SUVs, luxury vehicles, and tempo travellers depending on passenger requirements. Vehicles are maintained for smooth highway performance and passenger comfort. Professional chauffeurs ensure safe and timely transportation services. Pickup services are available across Pune with flexible booking options for business travel, family vacations, and group tours."
  },
  {
    name: "One Way Outstation Cab Pune",
    description: "One way outstation cab Pune service offers economical transportation for passengers traveling to other cities without return travel requirements. Comfortable vehicles provide smooth highway journeys with professional drivers ensuring punctual pickup and safe driving. Ideal for airport transfers, business travel, family visits, and tourism trips. Pickup services are available from homes, offices, hotels, railway stations, and airports in Pune. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune Outstation Cab Booking",
    description: "Pune outstation cab booking service allows travelers to reserve comfortable vehicles for long-distance journeys from Pune. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and luxury cars suitable for various travel requirements. Professional drivers ensure reliable and safe highway travel for passengers. Pickup services are available across Pune including residential areas, corporate offices, hotels, and airport terminals. Flexible booking options allow advance and instant cab reservations."
  },
  {
    name: "Taxi Service Pune Outstation",
    description: "Taxi service Pune outstation provides dependable transportation solutions for intercity travel from Pune to various destinations. Well-maintained vehicles ensure passenger comfort during long-distance highway journeys. Experienced drivers offer safe driving and punctual pickup services for business travelers, tourists, and families. Pickup services are available from homes, offices, hotels, railway stations, and Pune Airport. Flexible booking options make travel planning simple and convenient."
  },
  {
    name: "Best Outstation Cab Pune",
    description: "Best outstation cab Pune service offers premium travel experience with comfortable vehicles and professional chauffeurs for long-distance travel. Vehicles provide spacious seating, luggage space, and smooth ride quality suitable for expressway and highway journeys. Professional drivers ensure punctual pickup and safe transportation services. Pickup services are available across Pune including hotels, offices, homes, railway stations, and airports. Flexible booking options allow convenient one-way and round-trip travel reservations."
  },
  {
    name: "Cheap Outstation Cab Pune",
    description: "Cheap outstation cab Pune service provides affordable travel options for passengers looking for economical intercity transportation from Pune. Comfortable vehicles ensure reliable highway travel while maintaining budget-friendly pricing. Professional drivers ensure safe journeys and punctual pickup services for travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient and cost-effective outstation travel planning."
  },
  {
    name: "Pune to Outstation Cab",
    description: "Pune to outstation cab service provides reliable transportation from Pune to popular tourist destinations, pilgrimage locations, business cities, and nearby towns. Vehicles include sedans, SUVs, and premium cars suitable for different travel needs and group sizes. Professional drivers ensure smooth and safe highway journeys for passengers. Pickup services are available across Pune including residential areas, hotels, offices, railway stations, and airports. Flexible booking options allow convenient cab reservations for one-way and round trips."
  },
  {
    name: "Pune Airport Outstation Taxi",
    description: "Pune Airport outstation taxi service offers comfortable airport pickup and drop transportation for passengers traveling to outstation destinations. Vehicles provide spacious seating and luggage capacity suitable for airport and highway travel. Professional drivers ensure punctual airport pickups and safe transportation services. Ideal for business travelers, tourists, and family travel needs. Flexible booking options allow passengers to schedule convenient airport outstation rides."
  },
  {
    name: "Innova Outstation Cab Pune",
    description: "Innova outstation cab Pune service provides premium SUV transportation for families and groups traveling from Pune to outstation destinations. Innova vehicles offer spacious seating, smooth ride quality, and comfortable luggage space suitable for highway journeys. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Flexible booking options allow convenient SUV travel reservations."
  },
  {
    name: "Sedan Outstation Cab Pune",
    description: "Sedan outstation cab Pune service offers economical and comfortable transportation for intercity travel from Pune. Sedan vehicles provide smooth highway performance and comfortable seating suitable for couples, solo travelers, and small families. Professional drivers ensure safe journeys and timely pickup services across Pune. Pickup services are available from residential areas, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "SUV Outstation Taxi Pune",
    description: "SUV outstation taxi Pune service provides spacious and comfortable transportation for passengers traveling to outstation destinations from Pune. SUV vehicles offer excellent highway performance, luggage capacity, and comfortable seating suitable for family trips and group travel. Professional drivers ensure safe and reliable transportation services throughout the journey. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Pune to Mumbai Cab Service",
    description: "Pune to Mumbai cab service provides reliable transportation between Pune and Mumbai with comfortable vehicles and experienced drivers. Vehicles are suitable for expressway travel ensuring smooth and safe journeys for passengers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for business travel, airport transfers, tourism, and family visits. Flexible booking options allow convenient one-way and round-trip travel reservations."
  }
],

tableData: [
  ["Pune Outstation Cab Service", "Outstation Cab Pune"],
  ["Pune Outstation Taxi", "Outstation Taxi Service Pune"],
  ["Pune Outstation Car Rental", "One Way Outstation Cab Pune"],
  ["Pune Outstation Cab Booking", "Taxi Service Pune Outstation"],
  ["Best Outstation Cab Pune", "Cheap Outstation Cab Pune"],
  ["Pune to Outstation Cab", "Pune Airport Outstation Taxi"],
  ["Innova Outstation Cab Pune", "Sedan Outstation Cab Pune"],
  ["SUV Outstation Taxi Pune", "Pune to Mumbai Cab Service"]
],



 whychoose: [
      {
        WhyChooseheading: "Professional Outstation Drivers",
        WhyChoosedescription: "Shivai Travels provides experienced and professional drivers for Pune outstation cab service. Drivers are familiar with major highways, tourist routes, and intercity travel destinations to ensure safe and smooth journeys."
      },
      {
        WhyChooseheading: "Affordable Outstation Cab Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable and transparent Pune outstation cab service pricing with no hidden charges. Customers receive complete fare details including tolls and driver charges before booking confirmation."
      },
      {
        WhyChooseheading: "24/7 Outstation Taxi Availability",
        WhyChoosedescription: "Our Pune outstation cab service operates 24 hours a day for business trips, family vacations, religious tours, and airport transfers. Customers can book taxis anytime based on their travel schedule."
      },
      {
        WhyChooseheading: "Clean & Comfortable AC Vehicles",
        WhyChoosedescription: "All vehicles provided by Shivai Travels are air-conditioned, regularly cleaned, and well maintained to provide comfortable long-distance travel experiences for passengers."
      },
      {
        WhyChooseheading: "One Way & Round Trip Booking Options",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way outstation cab service, round-trip taxi bookings, multi-day travel packages, and customized tour plans from Pune."
      },
      {
        WhyChooseheading: "Wide Range of Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for family tours, group travel, and corporate trips."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides doorstep pickup from homes, offices, hotels, railway stations, and airport locations across Pune including Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, and Pimpri Chinchwad."
      },
      {
        WhyChooseheading: "Reliable Pune Outstation Cab Service",
        WhyChoosedescription: "Shivai Travels is trusted by travelers for reliable Pune outstation cab service with punctual pickups, professional drivers, comfortable vehicles, and smooth intercity transportation."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune outstation cab service?", answer: "Pune outstation cab service provides taxi transportation from Pune to nearby cities, tourist destinations, and long-distance travel locations." },
    { question: "Is Pune outstation cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune outstation cab service for all travel requirements." },
    { question: "Which vehicles are available for outstation travel?", answer: "Shivai Travels offers sedan cars, Ertiga, Innova, Innova Crysta, and Tempo Travellers for outstation trips." },
    { question: "Can I book a one-way outstation cab from Pune?", answer: "Yes, customers can book both one-way and round-trip outstation taxi services from Pune." },
    { question: "Do you provide pickup from Pune Airport?", answer: "Yes, Shivai Travels provides pickup and drop services from Pune Airport, railway stations, hotels, and residential areas." },
    { question: "Are all outstation taxis air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned and maintained for comfortable long-distance travel." },
    { question: "Can I book outstation cabs online?", answer: "Yes, customers can easily book Pune outstation cabs online or through phone booking." },
    { question: "Do you provide cab service for family trips?", answer: "Yes, Shivai Travels provides comfortable vehicles for family tours, vacations, and group travel." },
    { question: "Are toll charges included in the fare?", answer: "Fare details depend on the travel package selected. Shivai Travels provides transparent pricing before booking confirmation." },
    { question: "Is advance booking available for outstation travel?", answer: "Yes, advance booking is recommended for weekends, holidays, and long-distance travel plans." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback:
      "Shivai Travels provided a smooth Pune outstation cab experience with a clean vehicle and a skilled driver who ensured safe and comfortable long-distance travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Deshmukh",
    feedback:
      "For my outstation journey from Pune, the cab service was highly reliable with timely pickup and a comfortable ride throughout the trip.",
    rating: 5
  }
];











































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Outstation Cab Service",
  "image": "https://shivaitravels.com/assets/images/outstation-cab.jpg",
  "description": "Book Pune outstation cab service for comfortable and affordable travel. We provide one-way and round trip outstation taxi service from Pune to Mumbai, Shirdi, Goa, and other destinations. Sedan, SUV, Innova, and luxury cab options available with 24x7 support.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-outstation-cab-service"
  }
};





  return (
    <div>


<Helmet>
  <title>Pune Outstation Cab Service | Best & Affordable Taxi Service | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune outstation cab service for Mumbai, Shirdi, Goa and more. Affordable one-way & round trip taxis, SUV, Innova & sedan cabs available with 24x7 reliable service."
  />

  <meta
    name="keywords"
    content="pune outstation cab service, outstation cab pune, pune outstation taxi, outstation taxi service pune, pune outstation car rental, one way outstation cab pune, pune outstation cab booking, taxi service pune outstation, best outstation cab pune, cheap outstation cab pune, pune to outstation cab, pune airport outstation taxi, innova outstation cab pune, sedan outstation cab pune, suv outstation taxi pune, Pune Outstation Cab Service, Best Outstation Cab Service in Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/1.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetooutstationcabservice;